import script from "./ProjectAdd.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectAdd.vue?vue&type=script&setup=true&lang=js"

import "./ProjectAdd.vue?vue&type=style&index=0&id=be7942e6&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-be7942e6"]])

export default __exports__